/**
 * Manual gate for student access to /schools — flip to true once ready.
 */
export const SCHOOL_BROWSE_ENABLED_FOR_STUDENTS = false
